export default __webpack_public_path__ + "static/media/Sliderimg01.75b74fe3.jpg";